import { getApp, getApps, initializeApp } from "firebase/app";
import { deleteToken, getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
};

const hasFirebaseConfig = Boolean(
  firebaseConfig.apiKey &&
  firebaseConfig.projectId &&
  firebaseConfig.messagingSenderId &&
  firebaseConfig.appId
);

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const messagingPromise = isSupported().then((supported) => {
  if (!supported || !hasFirebaseConfig) return null;
  return getMessaging(app);
});

export const requestFcmToken = async (serviceWorkerRegistration) => {
  const messaging = await messagingPromise;
  if (!messaging) return null;

  const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
  if (!vapidKey) {
    throw new Error("REACT_APP_FIREBASE_VAPID_KEY is missing.");
  }

  return getToken(messaging, {
    vapidKey,
    serviceWorkerRegistration,
  });
};

export const onForegroundFcmMessage = async (handler) => {
  const messaging = await messagingPromise;
  if (!messaging) return () => {};
  return onMessage(messaging, handler);
};

export const deleteFcmToken = async () => {
  const messaging = await messagingPromise;
  if (!messaging) return false;

  try {
    return await deleteToken(messaging);
  } catch (error) {
    console.warn("Failed to delete FCM token:", error);
    return false;
  }
};

export { app, firebaseConfig, hasFirebaseConfig };
